import { render, staticRenderFns } from "./SnackbarMessage.vue.js?vue&type=template&id=58a9bdb6!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SnackbarMessage.vue?vue&type=template&id=58a9bdb6"
import script from "./SnackbarMessage.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SnackbarMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SnackbarMessage.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SnackbarMessage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports